import { useAuthContext } from '@core/shared';
import { ContainerDefault, ErrorMessagePage } from '@core/ui';
import { Link } from '@online-webinar/ui-frontend';
import { useTranslation } from 'react-i18next';
import { AccountManagementTabs } from '../../organism';
import { ProfileHeading } from './../../atoms/ProfileHeading';

export const MyAccount = () => {
    const isMainAccount = useAuthContext().isMainAccount;
    const { t } = useTranslation();
    if (!isMainAccount) {
        return (
            <ErrorMessagePage errorSubject="Account.Profile" errorCode="NotAvailable">
                <Link to="/switch-account" variant="primary">
                    {t('Account.Menu.SwitchAccount')}
                </Link>
            </ErrorMessagePage>
        );
    }

    return (
        <ContainerDefault>
            <div className="mb-4">
                <ProfileHeading title="My Account" />
            </div>
            <div className="max-w-4xl">
                <AccountManagementTabs data-testid="changePasswordForm" />
            </div>
        </ContainerDefault>
    );
};
